import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import Header from './Header'
import Hero from './Hero'
import Logo from './Logo'
import Loader from './Loader'
import Render from './Render'

export {
  Header,
  Hero,
  Logo,
  Loader,
  PrivateRoute,
  PublicRoute,
  Render
}



// WEBPACK FOOTER //
// ./src/components/Layout/index.js